import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ZingChart from 'zingchart-react';
import zingchart from 'zingchart';
import * as chartFunctions from './chartFunctions';

export default class Chart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: {},
      chartInputValues: {},
      height: this.props.height
    };

  }

  componentDidMount() {
    this.setChartData();
    zingchart.bind(this.props.id, 'complete', (chart) => {
      chartFunctions.postRenderAdjustments(chart, this.props, zingchart.exec);
    });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    let setStateObject = { type: newProps.type };
    
    if (newProps.height !== this.props.height) {
      setStateObject.height = newProps.height;
    }
    
    this.setState(setStateObject, this.setChartData);
  }

  setChartData = () => {
    this.setState({ chartData: chartFunctions.dataBuilder(this.props) });
  }

  render() {
    // Makes sure id and type are provided and that the type is not an image
    if (this.props.id && this.props.type && this.props.type !== "image") {
      return (
        <span className="chart">
          <ZingChart
            data={this.state.chartData}
            height={this.state.height}
            id={this.props.id}
            key={this.state.height}
            width={this.props.width}
          />
        </span>
      )
    }
    // Needed in order for tests to not break
    else {
      return <span></span>;
    }
  }
}

Chart.defaultProps = {
  overallBenchmark: false,
  showLegend: false
};

Chart.propTypes = {
  betterArrowDirection: PropTypes.oneOf(["up", "down", null]),
  data: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    )
  ),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string, // is actually required, but can't be set as isRequired because of tests
  legendOnTop: PropTypes.bool,
  overallBenchmark: PropTypes.bool,
  showLegend: PropTypes.bool,
  type: PropTypes.string,
  width: PropTypes.string,
  xAxisLabel: PropTypes.string,
  yAxisLabel: PropTypes.string,
  yMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  yMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  ySteps: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
